import { Gallery } from "src/libs/useful"
import { IPrimitiveProps } from "../section/Primitive"
import { GalleryContent } from "src/modules/pe-landing-module/data/interfaces"
import { Fragment } from "react"
import { components } from "src/modules/pe-landing-module/data/utils/components"
import { HTML as _HTML } from "../contentType"  
import useComponentData from "src/modules/pe-landing-module/hooks/useComponentData"

/* Protopia Ecosystem component */  
const GalleryPrimitive = (props: IPrimitiveProps): JSX.Element => {  
    const primitive: GalleryContent  = useComponentData<GalleryContent>(( props.primitive || {dimentions: {}} ) as GalleryContent )
    if(!primitive.items?.length) return <></>
    
    const items = primitive.items.map((item, i) => {
        if(item.isHidden) {
                return <Fragment key={ item.id }></Fragment>
            }
            const type = item.type
            const DataComponent = type && components()[ type ]
                ?
                components()[ type ].c
                :
                _HTML 
            return <DataComponent 
                key={i + "_" + item.id} 
                section={ { data: [ { ...primitive } ]} } 
                data={ {...item, type: item.type } } 
            /> 
    })

    return <Gallery {...{
            ...primitive, 
            items,
            type: primitive.galleryType || "element", 
            loop: primitive.loop || true,
            "data-primitive-type": primitive["data-primitive-type"] 
        }} /> 
}
export default GalleryPrimitive